// extracted by mini-css-extract-plugin
export default {"contactUsBox":"ContactUs_contactUsBox__9JrXN"};